import { fetchOkapiMarketingCode } from './fetch/okapi-fetch';

let fetching = false;

export const isMarketingCodeFetching = (): boolean => fetching;

export const getMarketingCode = async (marketingCode: string): Promise<any | null> => {
	fetching = true;
	try {
		const response = await fetchOkapiMarketingCode(marketingCode);
		return response?.content?.consolidatedData ?? null;
	} finally {
		fetching = false;
	}
};
